module.exports = __webpack_public_path__ + "img/1c.433e7e05.svg";